document.addEventListener('DOMContentLoaded', function () {
    const bullets = document.querySelectorAll('.shields__bullet');
    const mobileButtons = document.querySelectorAll('.shields__middle-mobile-button');
    const middles = document.querySelectorAll('.shields__middle');
    const breakpoint = 992; // Breakpoint for screen width
    let previousWidth = window.innerWidth; // Variable to store previous window width

    // Function to toggle the height of shields__bullet
    const toggleHeight = (bullet) => {
        const bulletContent = bullet.querySelector('.shields__bullet-content');
        const subbullets = bullet.querySelector('.shields__subbullets');
        const subbulletsWrap = bullet.querySelector('.shields__subbullets-wrap');
        const middle = bullet.closest('.shields__middle'); // Find the closest shields__middle

        if (subbullets && subbulletsWrap && bulletContent) {
            if (bulletContent.classList.contains('shields__bullet-content--active')) {
                // Reset shields__subbullets-wrap height
                subbulletsWrap.style.height = '0px';
                bulletContent.classList.remove('shields__bullet-content--active');

                // Check if the screen width is less than the breakpoint
                if (window.innerWidth < breakpoint && middle) {
                    // Only remove the added subbullets height, leave the original height of middle
                    const middleCurrentHeight = middle.scrollHeight - subbullets.scrollHeight;
                    middle.style.height = `${middleCurrentHeight}px`;
                }
            } else {
                // Set the height for shields__subbullets-wrap
                const subbulletsHeight = subbullets.scrollHeight;
                subbulletsWrap.style.height = `${subbulletsHeight}px`;
                bulletContent.classList.add('shields__bullet-content--active');

                // Check if the screen width is less than the breakpoint
                if (window.innerWidth < breakpoint && middle) {
                    // Add the subbullets height to the current height of middle
                    const middleCurrentHeight = middle.scrollHeight + subbulletsHeight;
                    middle.style.height = `${middleCurrentHeight}px`;
                }
            }
        }
    };

    // Function to toggle the height of shields__middle
    const toggleMiddleHeight = (button) => {
        const middle = button.nextElementSibling;  // Find the shields__middle
        if (middle && middle.classList.contains('shields__middle')) {
            const middleContent = middle.querySelector('.shields__middle-content');
            if (middleContent) {
                if (button.classList.contains('shields__middle-mobile-button--active')) {
                    middle.style.height = '0px';  // Reset height
                    button.classList.remove('shields__middle-mobile-button--active');
                } else {
                    const middleContentHeight = middleContent.scrollHeight;
                    middle.style.height = `${middleContentHeight}px`;
                    button.classList.add('shields__middle-mobile-button--active');
                }
            }
        }
    };

    // Event listener for shields__bullet clicks
    bullets.forEach(bullet => {
        bullet.addEventListener('click', function () {
            toggleHeight(bullet);
        });
    });

    // Event listener for shields__middle-mobile-button clicks
    mobileButtons.forEach(button => {
        button.addEventListener('click', function () {
            toggleMiddleHeight(button);
        });
    });

    // Restore the original state when the window is resized
    window.addEventListener('resize', function () {
        if (window.innerWidth !== previousWidth) { // Check if the screen width has changed
            bullets.forEach(bullet => {
                const bulletContent = bullet.querySelector('.shields__bullet-content');
                const subbulletsWrap = bullet.querySelector('.shields__subbullets-wrap');
                const middle = bullet.closest('.shields__middle');

                // Reset shields__subbullets-wrap and bullet-content on every resize
                if (bulletContent && subbulletsWrap) {
                    subbulletsWrap.style.height = '0px';
                    bulletContent.classList.remove('shields__bullet-content--active');
                }

                // Reset or remove height of shields__middle based on screen width
                if (middle) {
                    if (window.innerWidth >= breakpoint) {
                        // Absolutely remove height for screens 992px and larger
                        middle.style.removeProperty('height'); // Remove height style
                    } else {
                        // Reset height for smaller screens (below 992px)
                        middle.style.height = '0px';
                    }
                }
            });

            // Reset for shields__middle in case of screen width changes
            mobileButtons.forEach(button => {
                const middle = button.nextElementSibling;
                if (middle && middle.classList.contains('shields__middle')) {
                    // Reset height on window resize
                    if (window.innerWidth >= breakpoint) {
                        middle.style.removeProperty('height'); // Remove height style for >= 992px
                    } else {
                        middle.style.height = '0px';
                    }
                    button.classList.remove('shields__middle-mobile-button--active');
                }
            });

            previousWidth = window.innerWidth; // Update the previous width
        }
    });

    // Set height based on the data-open-for-mobile attribute
    middles.forEach(middle => {
        const button = middle.previousElementSibling; // Find the shields__middle-mobile-button
        const middleContent = middle.querySelector('.shields__middle-content');
        if (middleContent && middle.getAttribute('data-open-for-mobile') === 'true' && window.innerWidth < breakpoint) {
            const middleContentHeight = middleContent.scrollHeight;
            middle.style.height = `${middleContentHeight}px`;
            button.classList.add('shields__middle-mobile-button--active');
        }
    });
});
